<template>
    <div>
        <div class="course-list">
            <div
                class="course-list-item"
                v-for="(item, index) in courseList"
                :key="index"
            >
                <img
                    :src="item.cover"
                    alt=""
                    class="course-list-item-bg"
                    @click="toDetail(item)"
                />
                <div class="course-list-item-info">
                    <div style="display: flex; justify-content: space-between">
                        <div
                            class="course-list-item-info-status"
                            :class="`status${item.liveStatus}`"
                        >
                            {{ statusText[item.liveStatus] }}
                        </div>
                        <div
                            v-if="item.liveStatus === 0"
                            class="course-list-item-info-urge"
                            :class="urgeId === item.id ? 'ani' : ''"
                            @click="urge($event, item.id)"
                        >
                            <img src="@/assets/images/urge.png" alt="" /> 想看，催一下
                        </div>
                    </div>
                    <div class="course-list-item-info-title" :title="item.title">
                        {{ item.title }}
                    </div>
                    <div class="course-list-item-info-substra" :title="item.subtitle">
                        {{ item.subtitle }}
                    </div>
                    <div class="course-list-item-info-tag">
                        <span
                            v-for="(tag, i) in item.tags ? item.tags.split(',').filter((item) => item) : []"
                            :key="index + tag + i"
                            >#{{ tag }}</span
                        >
                    </div>
                    <div class="course-list-item-info-priceInfo">
                        <span class="course-list-item-info-priceInfo-price"
                            >¥ {{ item.price }}
                            <!-- <span
                                v-if="item.originalPrice"
                                class="course-list-item-info-priceInfo-org"
                                >¥{{ item.originalPrice }}</span
                            > -->
                        </span>
                    </div>
                    <div class="course-list-item-info-author">
                        <div>
                            <el-avatar
                                :size="30"
                                :src="item.teacherAvatar"
                                class="course-list-item-info-author-avatar"
                            ></el-avatar
                            ><span>{{ item.teacherName }}</span>
                        </div>
                        <el-button
                            :type="item.liveStatus ? 'primary' : 'disabled'"
                            @click="toDetail(item)"
                        >
                            我要学习
                            <i
                                class="el-icon-arrow-right"
                                style="margin-left: 8px; font-weight: 600; font-size: 10px"
                            ></i>
                        </el-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="loading" v-show="loading">
            <i class="el-icon-loading"></i>
        </div>
        <!-- 分页组件，根据需要显示 -->
        <div class="course-list__pagination" v-if="pagination">
            <el-pagination
                background
                layout="prev, pager, next"
                :hide-on-single-page="true"
                :page-size="pageSize"
                :current-page="pageNum"
                :total="total"
                @current-change="handlePageChange"
            >
            </el-pagination>
        </div>
    </div>
</template>

<script>
import debounce from "lodash/debounce";
import { urgeReq } from "@/api/courses";

export default {
    name: "CourseList",
    inject: {
        checkToken: {
            default: () => () => true
        }
    },
    props: {
        courseList: {
            type: Array,
            default: () => []
        },
        loading: {
            type: Boolean,
            default: false
        },
        pagination: {
            type: Boolean,
            default: true
        },
        pageSize: {
            type: Number,
            default: 20
        },
        pageNum: {
            type: Number,
            default: 1
        },
        total: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            statusText: ["待开课", "已开课", "正在直播", "已完课", "报名中"],
            urgeId: ""
        };
    },
    methods: {
        /**
         * 戳一戳
         */
        urge: debounce(function(e, id) {
            if (!this.checkToken()) return;
            this.urgeId = id;
            urgeReq(id).then(() => {
                this.$message.success("作者已经收到了您的敦促～请耐心等候哟");
                setTimeout(() => {
                    this.urgeId = "";
                }, 1000);
            });
        }, 500),
        toDetail(course) {
            if (course.liveStatus === 0) return;
            this.$router.push(`/courses/detail/${course.id}`);
        },
        handlePageChange(pageNum) {
            this.$emit('page-change', pageNum);
        }
    }
};
</script>

<style lang="scss" scoped>
.el-button {
    padding: 12px;
    &--primary {
        background-color: #0057ff;
        box-shadow: 0 10px 30px 0 rgba(0, 0, 0, 0.15);
        border-color: #0057ff;
        color: #fff;
        &:hover {
            background-color: #0057ff;
            border-color: #0057ff;
        }
    }
}
.course-list {
    padding: 20px 0;
    &-item {
        display: flex;
        margin-bottom: 20px;
        &-bg {
            border-radius: 8px;
            width: 73.8%;
            cursor: pointer;
        }
        &-info {
            position: relative;
            margin-left: 20px;
            padding: 20px;
            background-color: #fff;
            border-radius: 8px;
            width: 25%;
            min-width: 300px;

            &-status {
                padding: 6px 12px;
                background-color: #2f54eb;
                border-radius: 4px;
                text-align: center;
                @include font(#fff, 12px, 600);
                &.status3 {
                    background-color: #0057ff;
                }
                &.status4 {
                    background-color: #0057ff;
                }
            }
            &-urge {
                position: relative;
                padding: 0 10px;
                background-color: #f48370;
                box-shadow: 0 6px 12px 0 rgba(0, 0, 0, 0.1);
                border-radius: 4px;
                height: 24px;
                line-height: 24px;
                font-size: 12px;
                color: #fff;
                cursor: pointer;
                &.ani {
                    animation: urge 1s;
                }
            }
            &-title {
                margin-top: 20px;
                @include font(#272c40, 20px, 400);
                @include ellipse(100%);
                line-height: 30px;
            }
            &-substra {
                margin-top: 15px;
                @include font(#666, 16px, 400);
                @include ellipse(100%);
            }
            &-tag {
                margin: 20px 0;
                @include font(#597ef7, 12px, 400);
                > span {
                    margin-right: 10px;
                    padding: 4px 10px;
                    background: rgba(89, 126, 247, 0.1);
                    border-radius: 12px;
                }
            }
            &-priceInfo {
                &-price {
                    @include font(#eb793c, 20px, 600);
                }
                &-org {
                    @include font(#bbb, 14px, 600);
                    text-decoration: line-through;
                    font-style: italic;
                }
            }
            &-author {
                display: flex;
                justify-content: space-between;
                align-items: center;
                width: calc(100% - 40px);
                @include font(#333, 14px, 400);
                &-avatar {
                    margin-right: 10px;
                    vertical-align: middle;
                }
                a.disabled {
                    color: #333;
                    opacity: 0.3;
                }
            }
        }
    }
    &__pagination {
        margin-top: 45px;
        min-height: 10px;
        text-align: center;
    }
}
@keyframes urge {
    0% {
        right: -10px;
    }
    30% {
        right: -2px;
    }
    45% {
        right: -8px;
    }
    60% {
        right: -2px;
    }
    80% {
        right: -5px;
    }
    100% {
        right: 0px;
    }
}

@include mq($small) {
    .course-list-item {
        &-info {
            &-title {
                margin-top: 8px;
            }
            &-substra {
                margin-top: 5px;
                font-size: 14px;
            }
            &-tag {
                margin: 12px 0;
                line-height: 1;
                > span {
                    padding: 3px 8px;
                }
            }
            &-author {
                bottom: 10px;
            }
        }
    }
}
</style> 